import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import ListView from '../Common/ListView.react';
import ModuleActions from '../../actions/ModuleActionCreator';
import MyClassesStore from '../../stores/MyClassesStore';
import ModuleListItem from './ModuleListItem.react';

class MyClassList extends Component {

    componentDidMount() {
        ModuleActions.getMyClasses();
    }
    
    render() {
        return (
             <ListView
                title="My classes"
                sortOptions={this.props.sortOptions}
                sortAction={ModuleActions.getMyClasses}
                items={this.state.classes}
                itemDecorator={ModuleListItem}
            />
        );
    }
}

MyClassList.contextTypes = {
    auth:   PropTypes.object.isRequired
};

MyClassList.getStores = () => ([MyClassesStore]);
MyClassList.calculateState = (prevState) => ({
    classes:    MyClassesStore.getState()
});

MyClassList.propTypes = {
    sortOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label:  PropTypes.string.isRequired,
            value:  PropTypes.string.isRequired
        })
    )
};
MyClassList.defaultProps = {
    sortOptions: [
        { label: "Name",    value: 'name'},
        { label: "Code",    value: 'code'},
        { label: "Created", value: 'dateAdded'}
    ]
};

export default Container.create(MyClassList);
